import type { ContactPoint, Organization, PostalAddress } from 'schema-dts';

import constants from '../../../ahm-constants';

const CANONICAL_DOMAIN = 'https://ahm.com.au';
const CORPORATION_ID = `${CANONICAL_DOMAIN}/#corporation`;
const WEBSITE_ID = `${CANONICAL_DOMAIN}/#website`;

export const AHM_CORPORATION = {
  AREA_SERVED: 'Australia',
  CONTACT_POINTS: [
    {
      '@type': 'ContactPoint',
      areaServed: 'Australia',
      availableLanguage: 'English',
      contactType: 'customer service',
      email: constants.UI.CONTACT.EMAIL.INFO,
    },
    // TODO: TED-46 satisfies is the right type to use here (more safe) but unsupported until we upgrade to Next 13.1
    // ] satisfies ContactPoint[],
  ] as ContactPoint[],
  DESCRIPTION:
    'Insuring you for the things you’ll actually use. Don’t waste a cent! Smart, affordable health cover. Join online.',
  EMAIL: constants.UI.CONTACT.EMAIL.INFO,
  FOUNDING_DATE: '1971',
  ID: CORPORATION_ID,
  IMAGE_URL: `${CANONICAL_DOMAIN}/assets/img/default-fb.jpg`,
  KNOWS_ABOUT: 'Private Health Insurance',
  LEGAL_NAME: 'ahm health insurance',
  LOGO_URL: `${CANONICAL_DOMAIN}/assets/img/ahm-logo-alt-2x.png`,
  NAME: 'ahm',
  PARENT_ORGANIZATION: {
    '@type': 'Organization',
    name: 'Medibank Private Limited',
    // TODO: TED-46 satisfies is the right type to use here (more safe) but unsupported until we upgrade to Next 13.1
    // } satisfies Organization,
  } as Organization,
  POSTAL_ADDRESS: {
    '@type': 'PostalAddress',
    addressCountry: 'AU',
    streetAddress: constants.UI.CONTACT.ADDRESS.PHYSICAL,
    // TODO: TED-46 satisfies is the right type to use here (more safe) but unsupported until we upgrade to Next 13.1
    // } satisfies PostalAddress,
  } as PostalAddress,
  SAME_AS: [
    constants.URLS.SOCIAL.AHM_FACEBOOK,
    constants.URLS.SOCIAL.AHM_INSTAGRAM,
    constants.URLS.SOCIAL.AHM_TWITTER,
    constants.URLS.SOCIAL.AHM_YOUTUBE,
  ],
  TELEPHONE: constants.UI.CONTACT.PHONE.PRETTY,
  URL: CANONICAL_DOMAIN,
} as const;

export const AHM_WEBSITE = {
  ID: WEBSITE_ID,
  NAME: 'ahm health insurance',
  PUBLISHER: { '@id': CORPORATION_ID },
  URL: CANONICAL_DOMAIN,
} as const;
